module.exports = __webpack_public_path__ + "img/bs.2526f251.svg";